import React, {ChangeEvent} from 'react';

import {PossibleValueInput} from 'src/modules/event-create/attributes-block/typedefs';

import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Input} from '@pb/kit-component-input-v2';

import {MAX_LENGTH_POSSIBLE_VALUE} from '../../../validations/possible-values-validation';

type Props = {
    index: number,
    possibleValue: PossibleValueInput,
    onBlur: (event: React.FocusEvent<HTMLInputElement>, name?: string) => void,
    onChange: (event: ChangeEvent<HTMLInputElement>) => void,
    onClearInputValue: (index: number) => void,
};

export const PossibleValuesModalInputItem = (props: Props) => {
    const {
        index,
        possibleValue,
        onBlur,
        onChange,
        onClearInputValue,
    } = props;

    const onClearInput = () => {
        onClearInputValue(index);
    };

    return (
        <Input
            maxLength={MAX_LENGTH_POSSIBLE_VALUE}
            placeholder={possibleValue.isEmptySlot ? 'Possible Value' : undefined}
            value={possibleValue.value}
            name={`${index}`}
            onBlur={onBlur}
            onChange={onChange}
            endAdornment={!possibleValue.isEmptySlot && (
                <BasicIconButton iconProps={{type: Icons.TRASH_LIGHT}} onClick={onClearInput}/>
            )}
        />
    );
};
